import React, { useState, useEffect } from 'react';
import { Check, X, Shield, ShieldAlert, Lock, EyeOff, Eye } from 'lucide-react';
import './PasswordValidator.css';

export default function PasswordValidator({
    value,
    onChange,
    onValidityChange,
    disabled
}) {
    const [showPassword, setShowPassword] = useState(false);

    // 1. Core complexity validation logic
    const hasMinLength = value.length >= 8;
    const hasNumber = /[0-9]/.test(value);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);
    const isPasswordComplex = hasMinLength && hasNumber && hasSpecialChar;

    // 2. Alert the parent component immediately when the validity status flips
    useEffect(() => {
        if (onValidityChange) {
            onValidityChange(isPasswordComplex);
        }
    }, [isPasswordComplex, onValidityChange]);

    return (
        <div className="input-group">
            <label htmlFor="new-password">New Password</label>
            <div className="input-field-wrapper">
                <Lock className="input-icon" size={20} />
                <input
                    id="new-password"
                    type={showPassword ? 'text' : 'password'}
                    placeholder="Enter new password"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    required
                    disabled={disabled}
                />
                <button
                    type="button"
                    className="visibility-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                >
                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
            </div>

            {/* Real-Time Security Checklist */}
            {value && (
                <div className="requirements-box">
                    <p className="requirements-title">Password Security Checklist:</p>

                    <div className={`requirement-item ${hasMinLength ? 'met' : 'unmet'}`}>
                        {hasMinLength ? <Check size={14} /> : <X size={14} />}
                        <span>Minimum 8 characters</span>
                    </div>

                    <div className={`requirement-item ${hasNumber ? 'met' : 'unmet'}`}>
                        {hasNumber ? <Check size={14} /> : <X size={14} />}
                        <span>At least 1 number (0-9)</span>
                    </div>

                    <div className={`requirement-item ${hasSpecialChar ? 'met' : 'unmet'}`}>
                        {hasSpecialChar ? <Check size={14} /> : <X size={14} />}
                        <span>At least 1 special character (!@#$...)</span>
                    </div>
                </div>
            )}
        </div>
    );
}